export default "__VITE_ASSET__19756e47__"